import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import BasicInfoForm from '../ui/BaseInfoForm';
// [버튼] 하단 컨테이너 공통 컴포넌트
import { BottomBar } from '../ui/BottomActionBar';
import TypeWork from '../ui/TypeWork';
import Complete from '../ui/Complete';
import BackClickBottomSheet from '../ui/BackClickBottomSheet';
import SelectDepHeadIdBottomSheet from '../ui/SelectDepHeadIdBottomSheet';
import WriteCheckListCommon from '../ui/WriteCheckListCommon';
import SignBottomSheet from '../ui/SignBottomSheet';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import Sign from '../ui/Sign';

export default function M_PER_NEW_01(props) {
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { navBar } = useSelector((state) => state.systemBar);
  const baseInfo = useSelector((state) => state.permit.baseInfo);
  const { approvalLine } = useSelector((state) => state.permit);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { depHeads, safetyManager, observer } = approvalLine;
  const signatureCanvas = useRef(null);
  const activeStep = useSelector((state) => state.common.activeStep);

  const risksRef = useRef(null);
  const equipsRef = useRef(null);
  const preparationsRef = useRef(null);
  const etcContentRef = useRef(null);

  const checklistRefs = {
    3: risksRef,
    4: equipsRef,
    5: preparationsRef,
    6: etcContentRef,
  };

  const stepConfigs = {
    1: { title: '작업개요', component: <BasicInfoForm {...props} /> },
    2: { title: '작업종류', component: <TypeWork Search2={props.Search2} /> },
    3: {
      title: '유해위험요인',
      component: (
        <WriteCheckListCommon
          ref={risksRef}
          title="유해위험요인"
          codeListKey="risks"
        />
      ),
    },
    4: {
      title: '보호구',
      component: (
        <WriteCheckListCommon
          ref={equipsRef}
          title="보호구"
          codeListKey="equips"
        />
      ),
    },
    5: {
      title: '안전조치 사항',
      component: (
        <WriteCheckListCommon
          ref={preparationsRef}
          title="안전조치 사항"
          codeListKey="preparations"
          handleChange={props.handleChange}
          errors={props.errors}
        />
      ),
    },
    6: {
      title: '기타 특이사항',
      component: (
        <WriteCheckListCommon
          ref={etcContentRef}
          title="기타 특이사항"
          codeListKey="etcContent"
          {...props}
        />
      ),
    },
    7: {
      title: '서명 요청',
      component: <Sign />,
    },
    8: { title: '완료', component: <Complete /> },
  };

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 허가서 신청'));
    dispatch(CommonActions.setActiveStep(1));
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [activeStep]);

  const handleNextStep = () => {
    if (activeStep === 1) {
      if (props.ValidateAll && !props.ValidateAll()) return;
    }
    if (activeStep === 2) {
      const selectedWorkTypes = Array.isArray(baseInfo.workTypes)
        ? baseInfo.workTypes
        : [];
      if (selectedWorkTypes.length === 0) {
        dispatch(
          showSnackbar({
            message: '작업 종류를 최소 한 가지 선택해주세요.',
            type: 'warning',
          })
        );
        return;
      }
      const MAIN_WORK_TYPES = ['WT_001', 'WT_002'];
      const hasMain = selectedWorkTypes.some((t) =>
        MAIN_WORK_TYPES.includes(t)
      );
      if (!hasMain) {
        dispatch(
          showSnackbar({
            message:
              '보조 작업은 일반작업 또는 화기작업과 함께 선택해야 합니다.',
            type: 'warning',
          })
        );
        return;
      }
    }

    if (activeStep >= 3 && activeStep <= 6) {
      const currentRef = checklistRefs[activeStep];
      if (currentRef?.current?.validateAndNavigate) {
        const isValid = currentRef.current.validateAndNavigate();
        if (!isValid) return;
      }
    }

    if (activeStep === 7) {
      if (depHeads.length === 0 || !safetyManager || !observer) {
        dispatch(
          showSnackbar({
            message: '모든 결재자와 입회자를 선택해주세요.',
            type: 'warning',
          })
        );
        return;
      }

      const myId = String(userInfo?.decUserId || '');
      const safetyId = String(safetyManager.smId);

      const hasDuplicate = depHeads.some(
        (h) => String(h.headId) === safetyId
      );
      if (hasDuplicate) {
        dispatch(
          showSnackbar({
            message: '중간결재자와 최종결재자는 같은 사람일 수 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      if (myId) {
        const isSelfApprover =
          depHeads.some((h) => String(h.headId) === myId) ||
          safetyId === myId;
        if (isSelfApprover) {
          dispatch(
            showSnackbar({
              message: '본인은 결재자로 선택할 수 없습니다.',
              type: 'error',
            })
          );
          return;
        }
      }

      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: true,
          type: 'signAuthor',
        })
      );
      return;
    }

    dispatch(CommonActions.increaseStep());
    dispatch(BottomSheetActions.CloseBottomSheet());
  };

  const currentStep = stepConfigs[activeStep];
  const bottomReserveHeight =
    activeStep !== 8 ? `calc(${navBar}px + 108px)` : '24px';

  return (
    <Box
      ref={containerRef}
      sx={{
        px: 2,
        pb: '24px',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
      }}
    >
      {currentStep ? (
        currentStep.component
      ) : (
        <Navigate to="/M_Permit" replace />
      )}

      {activeStep !== 8 && (
        <Box
          aria-hidden="true"
          sx={{
            flexShrink: 0,
            height: bottomReserveHeight,
          }}
        />
      )}

      {/* [버튼] */}
      {activeStep !== 8 && (
        <BottomBar variant="default">
          <div className="mx-auto space-y-3">
            <div className="flex items-center justify-between px-1">
              <span className="text-md font-bold text-slate-400">
                {currentStep?.title || ''}
              </span>
              <span className="rounded-full bg-green-50 px-2.5 py-1 text-xs font-bold text-green-700">
                {activeStep} / 7
              </span>
            </div>

            <div className="relative h-1 w-full rounded-full bg-slate-100">
              <div
                className="bg-primary absolute top-0 left-0 h-full rounded-full transition-all duration-700 ease-out"
                style={{ width: `${(activeStep / 7) * 100}%` }}
              >
                <div className="bg-primary absolute top-1/2 -right-0.75 h-2 w-2 -translate-y-1/2 rounded-full shadow-sm ring-2 ring-white" />
              </div>
            </div>

            <div className="flex gap-3 overflow-hidden">
              <AnimatePresence mode="popLayout">
                {activeStep > 1 && activeStep <= 7 && (
                  <motion.button
                    layout
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -20, opacity: 0 }}
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                    onClick={() => dispatch(CommonActions.decreaseStep())}
                    className="flex-1 rounded-[14px] bg-slate-100 py-4 text-[15px] font-medium text-slate-600 active:scale-[0.98]"
                  >
                    이전
                  </motion.button>
                )}
              </AnimatePresence>

              {activeStep <= 8 && (
                <motion.button
                  layout
                  onClick={handleNextStep}
                  className={`${
                    activeStep === 1 ? 'w-full' : 'flex-2'
                  } bg-primary shadow-primary/20 flex items-center justify-between rounded-[14px] px-5 py-4 text-[15px] font-medium text-stone-100 active:scale-[0.98]`}
                  transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                >
                  <motion.span layout="position">
                    {activeStep === 7 ? '신청 하기' : '다음 단계'}
                  </motion.span>
                  <motion.svg
                    layout="position"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M3 8h10M9 4l4 4-4 4"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </motion.svg>
                </motion.button>
              )}
            </div>
          </div>
        </BottomBar>
      )}

      {bottomSheetState.bottom && bottomSheetState.type === 'backClick' && (
        <BackClickBottomSheet
          open={true}
          SearchLogic1={props.SearchLogic1}
          route={props.id ? `/M_Permit/detail/${props.id}` : '/M_Permit'}
        />
      )}

      {bottomSheetState.bottom &&
        bottomSheetState.type === 'selectDepHeadId' && (
          <SelectDepHeadIdBottomSheet Save1={props.Save1} />
        )}

      {bottomSheetState.bottom && bottomSheetState.type === 'signAuthor' && (
        <SignBottomSheet
          signatureCanvas={signatureCanvas}
          onComplete={() => {
            dispatch(CommonActions.increaseStep());
          }}
          Save1={async ({ gubun, signFile }) => {
            await props.Save1({
              depHeads,
              safetyManager,
              observer,
              signFile,
              gubun,
            });
          }}
        />
      )}
    </Box>
  );
}
